<div class="card sales-1 overflow-hidden rounded-10 shadow">
  <div class="card-body" *ngIf="isLoaded">
    <app-loading-dash [size]="'card-top'" />
  </div>
  <div class="card-body" *ngIf="!isLoaded">
    <span class="bg-secondary-transparent icon-service text-secondary float-end"
      ><i class="fe fe-pie-chart"></i>
    </span>
    <h6 class="mb-3">{{ 'common.todaysSales' | translate }}</h6>
    <h4 class="mb-1">
      <span class="number-font"
        >
        <span class="counter">{{
          salesToday
            | formatCurrency
        }}</span></span
      >
    </h4>
    <p class="mb-2" *ngIf="!salesTodayPositive">
      <span class="text-danger fs-13 me-2"
        >(-{{
          salesTodayPercent
            | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
        }}%)</span
      >
      <span class="small text-muted">{{ 'common.thanLastWeek' | translate}}</span>
    </p>
    <p class="mb-2" *ngIf="salesTodayPositive">
      <span class="text-success fs-13 me-2"
        >({{
          salesTodayPercent
            | mask : "separator.2" : { decimalMarker: ",", leadZero: true }
        }}%)</span
      >
      <span class="small text-muted">{{ 'common.thanLastWeek' | translate}}</span>
    </p>
  </div>
</div>
